import { PageFaqSection } from './ds';
import { FAQS } from '../data/faqs';

export function FAQ() {
  return (
    <PageFaqSection
      items={FAQS}
      initialOpenIndex={0}
      title={
        <>
          Asked &amp;
          <br />
          answered.
        </>
      }
    />
  );
}
